<template>
  <header id="header" class="pc">
    <div class="header-top">
      <div style="float: left">
        <h1 id="logo">
          <img src="../../../assets/web/images/logo.png" alt="문화셈터">
          <span>지도통계서비스</span>
        </h1>
      </div>
      <div class="util-option" style="display:flex;height:56px;justify-content: right;">
        <button type="button" id="help2">
          <i class="fa fa-th-list fa-2x" aria-hidden="true" v-on:click="showDataListModal()"></i>
        </button>
        <button type="button" id="help" style="margin-left:20px">
          <i class="fa fa-info-circle fa-2x" aria-hidden="true" v-on:click="showHelpModal()"></i>
        </button>
      </div>
    </div>
  </header>
</template>

<script>
import { mapActions } from 'vuex'
import { eventBus } from '@/event-bus'

const adminStore = 'adminStore'

export default {
  name: 'Header',
  mounted () {
    this.showDataListModal()
  },
  methods: {
    ...mapActions(adminStore, {
      adminUserLogout: 'logout'
    }),

    showHelpModal () {
      eventBus.$emit('showHelpBoard')
    },
    showDataListModal () {
      eventBus.$emit('showDataListBoard')
    },
    goAdmin () {
      // this.adminUserLogout('admin')
      this.$router.push({ name: 'AdminLogin' })
    }
  }
}
</script>

<!--<style scoped>-->
<!--@import '../../../assets/web/css/reset.css';-->
<!--@import '../../../assets/web/css/index.css';-->
<!--</style>-->
